
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[pageId]",
      function () {
        return require("private-next-pages/blog/[pageId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[pageId]"])
      });
    }
  